module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "zdjęcie"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.thumbnail,
            "alt": scope.row.alt_pl
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "autor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.photoDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].author),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "author", $$v)
            },
            expression: "duringEditing[scope.row.id].author"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.author))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (pl)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.photoDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_pl),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_pl", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_pl"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_pl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (en)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.photoDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_en),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_en", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_en"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_en))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.photoDuringEdition(scope.row)),
            expression: "!photoDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Edytuj szczegóły zdjęcia",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editPhoto(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.photoDuringEdition(scope.row)),
            expression: "photoDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Zatwierdź edycję",
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.submitEditedPhoto(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-check"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0331320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Gallery/Images/ImagesList.vue
// module id = 789
// module chunks = 0